export default {
  TYPE: {
    CREATED: { LABEL: 'Data de criação', KEY: 'created', VALUE: 'criação' },
    PAID: { LABEL: 'Data de pagamento', KEY: 'paid', VALUE: 'pagamento' },
  },
};
